import React from "react";

export default function RecipeSeasonTag({ season, isSinglePost }) {
    return (
        <div className={isSinglePost ? "recipe_season_tag_container_is_single_post" : "recipe_season_tag_container"}>
            <p>{season}</p>
        </div>
    )
}